<template>
  <v-card elevation="6" class="my-4 mx-4">
    <v-card-title style="color:#AF8936">
      <h3 class="grow hidden-xs-only">Toca Número: {{dataToca.identificador}} </h3>
       <v-spacer></v-spacer>
       <v-btn dark small  color="blue lighten-1" style="margin-right: 10px;" @click="notificarParte()">ENVIAR NOTIFICACIÓN</v-btn>

    </v-card-title>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="dataPartes"
          :single-select="singleSelect"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          item-key="id"
          show-select
          show-expand
          class="elevation-1"
        >
          <template v-slot:item.nombre="{ item }" >
            {{item.nombre}} {{item.primer_apellido}} {{item.segundo_apellido}}
          </template>
          <template v-slot:item.email="{ item }" >
            <span v-if="dataToca.sala_data.materia_id === 1">
              {{ item.email }}
            </span>
            <span v-else>
              {{ item.email_penal }}
            </span>
          </template>
          <template v-slot:item.pivot.acceso={item}>
            <v-chip class="ma-2" small color="green lighten-1" dark v-if="item.pivot.acceso == 2">Confirmado</v-chip>
          </template>
          <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
            <v-btn x-small color="secondary" dark @click="expand(true), getNotificaciones(item)" v-if="!isExpanded">Ver Notificaciones </v-btn>
            <v-btn x-small color="secondary" dark @click="expand(false)" v-if="isExpanded">Cerrar </v-btn>
          </template>

        <template v-slot:expanded-item="{headers, item}">
          <td :colspan="headers.length" style="padding: 0;">
            <v-data-table
              :headers="headers_notificaciones"
              :items="listNotificaciones"
              hide-default-footer
              class="elevation-1"
              :loading="loading"
              loading-text="Cargando Información"
            >
            <template v-slot:item.estado="{ item }" >
              <td v-if="item.estado == 0" class="mx-2" x-small color="blue-grey darken-1" dark>Pendiente</td>
              <td v-if="item.estado == 3" class="mx-2" x-small color="blue-grey darken-1" dark>Entregado</td>
              <td v-if="item.estado == 4" class="mx-2" x-small color="blue-grey darken-1" dark>Abierto</td>
              <td v-if="item.estado == 6 || item.estado == 7" class="mx-2" x-small color="blue-grey darken-1" dark>
                <v-chip
                  class="ma-2"
                  color="red"
                  text-color="white"
                  small
                >
                  No Entregado
                </v-chip>
              </td>
              <td v-if="item.estado == 9" class="mx-2" x-small color="blue-grey darken-1" dark>Notificado (24 hrs)</td>
            </template>
            <template v-slot:item.acuses="{ item }" >
              <v-btn v-if="item && item.fecha_envio!=null || (item.estado == 6 || item.estado == 7)" x-small color="grey darken-1" dark @click="acusePdf(item,'envio')">Envío</v-btn>
              &nbsp;
              <v-btn v-if="item && item.fecha_apertura!=null || item.estado== 9" x-small color="grey darken-1" dark @click="acusePdf(item,'apertura')">Apertura</v-btn>
            </template>
            <template v-slot:item.file="{ item }" >
              <v-btn v-if="item.documento!=null" x-small color="grey darken-1" dark @click="getFile(item)">Visualizar</v-btn>
            </template>
            </v-data-table>
          </td>
        </template>
  </v-data-table>

  <v-row justify="center" >
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card >
      <v-form>

      <v-toolbar dark color="primary">
        <v-toolbar-title>Enviar Notificación</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
    <v-container>
      <h2>La Notificación se enviará a:</h2>
      <v-col cols="12" sm="6" v-for="data in to">
        <v-chip >
          {{ data.name}} ({{ data.email }}),
        </v-chip>
      </v-col>
    <v-divider></v-divider>
      <v-col cols="10" md="8">
        <v-text-field
          v-model="addParte"
          label="Nombre de la Parte "
          required
        ></v-text-field>
        <v-btn small color="primary" dark @click="addPartes()">Agregar</v-btn>
      </v-col>
      <v-col cols="10" md="8">
        <ul>
          <li
            v-for="(parte,index) in notificacion.partes_generales"
            v-bind:key="parte"
            v-on:remove="notificacion.partes_generales.splice(index, 1)"
          >
          {{parte}}
          <v-btn x-small color="red darken-3" dark @click="removeParte(index)">X</v-btn>
        </li>
      </ul>
     </v-col>
    <v-divider></v-divider>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290px"
      >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="resolucion"
          label="Fecha de resolución"
          prepend-icon="mdi-calendar-outline"
          readonly
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker v-model="resolucion" @input="menu = false" locale="es-mx"></v-date-picker>
    </v-menu>
    <v-col cols="10" md="12">
      <v-text-field
        v-model="notificacion.asunto"
        label="Asunto"
        :rules="notBlankRules"
        required
      ></v-text-field>
    </v-col>
      <v-col cols="12" md="12">
      <v-card
          class="d-flex pa-2"
          outlined
          tile
          color="grey lighten-2">
          <div>Contenido de la Notificación</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <span class="title"></span>
        <vue-editor
          v-model="notificacion.contenido"
          outlined
          name="input-7-4"
          placeholder=""
          required
          :rules="notBlankRules"

        ></vue-editor>
      </v-col>
       <v-divider></v-divider>
       <br>
      <v-col cols="12" sm="12" md="12">
          <v-file-input
            v-model="file"
            color="blue darken-2"
            counter
            label="Adjuntar Archivo"
            multiple
            placeholder="Seleccione un archivo"
            prepend-icon="mdi-paperclip"
            outlined
            :rules="notBlankRules"
            @change="fileSelected()"
            accept="application/pdf"
          >
          </v-file-input>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <v-btn block color="primary" dark @click="enviarNotificacion()">Enviar</v-btn>
      </v-col>
    </v-container>
    <v-overlay :value="overlay">
      <v-row
        class="fill-height"
        align-content="center"
        justify="center"
      >
        <v-col
          class="subtitle-1 text-center"
          cols="12"
        >
          <h2>Cargando archivo, Por favor espere.</h2>
        </v-col>
        <v-col cols="6">
          <v-progress-linear
            color="white"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-col>
      </v-row>
    </v-overlay>
  </v-form>
    </v-card>

  </v-dialog>
  </v-row>

  <v-dialog
    hide-overlay
    v-model="loadingPdf"
    persistent
    width="400"
  >
    <v-card color="grey darken-3" dark style="padding-top: 19px;" class="text-center">
      <v-card-text>
        <b>Descargando PDF</b>
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-3"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>

</v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  const Swal = require('sweetalert2');
  import { VueEditor } from "vue2-editor";
  export default {
    props: ['toca_id'],
    data: () => ({
      selected:[],
      loadingPdf:false,
      singleSelect: false,
      expanded: [],
      expand:false,
      isExpanded:false,
      singleExpand:true,
      overlay:false,
      partes_id:[],
      files:[],
      file:[],
      parte_item:'',
      archivo:{
        encode:'',
        type:'',
        file_name:''
      },
      addParte: '',
      dataToca:[],
      dataPartes: [],
      listTocas:[],
      toca:'',
      dataParte:'',
      to:[],
      dialog: false,
      loading:false,
      valid: true,
      titleTabla: 'ÚLTIMOS REGISTROS:',
      headers: [
        { text: 'Nombre', value: 'nombre',sortable: false },
        { text: 'Correo electónico', value: 'email', sortable: false },
        { text: 'Estatus', value: 'pivot.acceso', sortable: false},
        { text: '', value: 'data-table-expand', sortable: false },
      ],
      headers_notificaciones: [
        { text: 'Fecha de envío', value: 'fecha_envio' },
        { text: 'Estado', value: 'estado'},
        { text: 'Fecha de Apertura', value: 'fecha_apertura'},
        { text: 'Asunto', value: 'asunto', sortable: false},
        { text: 'Notificador', value: 'notificador', sortable: false},
        { text: 'Acuses', value: 'acuses', sortable: false },
        { text: 'Archivo Adjunto', value: 'file', sortable: false }
      ],
      loadingTable: false,
      notificacion:{
        partes_generales:[],
        asunto:'',
        contenido:'',
        file:''
      },
      DefaultNotificacion:{
        partes_generales:[],
        asunto:'',
        contenido:'',
        file:''
      },
      listNotificaciones:[],
      notBlankRules: [v => !!v || 'Este campo es requerido'],
      emailRules: [
        v => !!v || 'El campo es requerido',
        v => /.+@.+\..+/.test(v) || 'Ingrese un correo válido',
      ],
      'resolucion' :'',
      menu: false,
    }),
    computed: {
      ...mapGetters([
        "listPartes","dataNotFound", "roleUser","token_",
      ]),
    },
    async mounted(){
      await this.getToca();
      await this.getPartesByToca();
    },
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    methods: {
      async getToca() {
        await this.$store
          .dispatch("SHOW_TOCA", this.toca_id)
          .then((response) => {
            this.dataToca = response.data.data.toca;
          })
          .catch(err => {
            console.log(err);
          });
      },
      async getPartesByToca() {
        await this.$store
          .dispatch("GET_PARTES_TOCA", {
            toca_id: this.toca_id,
            only_confirmed:true
          })
          .then((response) => {
           // console.log("el de notifica", response);
            Object.entries(response.data.data.partes).forEach(([key, laparte]) => {
              if(laparte.validada == 2){
                laparte.nombre = '( NV ) ' + laparte.nombre
              }
            });
            this.dataPartes = response.data.data.partes;
          })
          .catch(err => {
            console.log(err);
            //this.showAlert(this.notification);
          });
      },
      notificarParte(){
        if(this.selected==''){
          Swal.fire({
            icon: 'warning',
            title: 'Debe seleccionar las partes a notificar',
            showConfirmButton: false,
            timer: 1500
          })
        } else{
          this.selected.forEach( parte => {
            var email = parte.email
            if(this.dataToca.sala_data.materia_id === 2 ){
              email = parte.email_penal
            }
            var name = parte.nombre+' '+parte.primer_apellido+' '+parte.segundo_apellido
            this.to.push({ email: email, name: name } )
            var parte_id = parte.id
            this.partes_id.push(parte_id)
          })
          this.dialog = true
        }
      },
      enviarNotificacion() {
        if(this.file==""| this.notificacion.asunto==""  || this.notificacion.contenido=="" || this.notificacion.partes_generales==""){
          Swal.fire({
            icon: 'warning',
            title: 'Todos los Campos son obligatorios',
            showConfirmButton: false,
          })
        } else {
          this.FilesToUpload();
          this.overlay = true
          this.$store.dispatch("ENVIA_NOTIFICACION", {
            partes_id: this.partes_id,
            toca_id: this.toca_id,
            subject: this.notificacion.asunto,
            content: this.notificacion.contenido,
            partes_generales: this.notificacion.partes_generales,
            file:this.archivo,
            fecha_resolucion:this.resolucion,
          })
          .then((response) => {
            if (response.data.status == 'ok') {
                Swal.fire({
                  icon: 'success',
                  title: 'Notificación Enviada',
                  showConfirmButton: true,
                  confirmButtonText: 'Cerrar'
                })
              this.close();
              if(this.parte_item!==''){
                this.getNotificaciones(this.parte_item)
              }
            }
          })
          .catch(err => {
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'No se envió la notificación',
              showConfirmButton: true,
              confirmButtonText: 'Cerrar'
            })
            this.overlay = false
          });
         }
      },
      getNotificaciones(item){
        console.log('item',item);
        this.parte_item = item;
        this.loading = true
        this.listNotificaciones =[]
        this.$store
          .dispatch("GET_NOTIFICACIONES", this.parte_item)
          .then((response) => {
            this.listNotificaciones = response.data.notificaciones;
            this.loading = false
          })
          .catch(err => {
            console.log(err);
            this.listNotificaciones =[]
            this.loading = false
          });
      },
      fileSelected(){
        var file = this.file[0];
        this.getBase64(file).then(data => {
          this.files.push(data);
        });
      },
      getBase64(file) {
        return new Promise((resolve, reject) => {
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
          }
        });
      },
      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || "";
        sliceSize = sliceSize || 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        for (
          var offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },
      FilesToUpload() {
        if (this.files.length) {
          this.files.forEach(file => {
            var block = file.split(";");
            // Get the content type of the image
            var contentType = block[0].split(":")[1]; // In this case "jpg
            // get the real base64 content of the file
            this.archivo['type'] = contentType
            var realData = block[1].split(",")[1];
            //console.log(realData);
            this.archivo['encode'] = realData
            this.archivo['file_name'] = this.file[0].name
          });
        }
      },
      close () {
        setTimeout(() => {
          this.notificacion = Object.assign({}, this.DefaultNotificacion)
          this.dialog = false
          this.overlay = false
          this.to = []
          this.file = []
          this.notificacion.partes_generales = []
          this.partes_id = []
        }, 300)
      },
      acusePdf(item,tipo){
        this.loadingPdf = true
        this.$store.dispatch("GET_ACUSE", [item.id,tipo])
        .then((response)=>{
          this.loadingPdf = false
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          let toca = item.toca.identificador
          link.setAttribute('download', 'Acuse_Notificación_' + toca +'.pdf');
          document.body.appendChild(link);
          link.click();
        })
          .catch(err => {
            console.log(err);
          });
      },
      getFile(item){
        this.$store
          .dispatch("GET_FILE", item.id)
          .then((response) => {
            //this.loadingPdf = false
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('target' ,'_blank');
            //link.setAttribute('download', item.documento);
            document.body.appendChild(link);
            link.click();
          })
          .catch(err => {
            console.log(err);
          });
      },
      addPartes() {
        if (this.addParte=="") {
          Swal.fire({
            icon: 'warning',
            title: 'El campo esta vacío',
            showConfirmButton: false,
            timer: 1500
          })
        }else{
          this.notificacion.partes_generales.push(this.addParte)
          this.addParte = ''
        }
    },
    removeParte(index) {
      this.notificacion.partes_generales.splice(index, 1)
      },
    }
  };
</script>
